import React, { useEffect, useState } from 'react';

import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';

import { Box, Container, Typography } from '@mui/material';

import OfferBreadcrumbs from '~/components/Common/Elements/OfferBreadcrumbs';
import PageHeader from '~/components/Common/Elements/PageHeader';
import RoomTypesGroupsForm from '~/components/Common/Forms/RoomTypesGroupsForm';
import Spinner from '~/components/Common/Spinner';

import ReservationService from '~/services/ReservationService';
import VendorsService from '~/services/VendorsService';

export default function RoomTypesGroupEditContainer() {
  const { id_vendor: vendorId, id_property: propertyId } = useParams<{ id_vendor: string; id_property: string }>();

  const [loadingState, setLoadingState] = useState<Utils.FetchingState>('loading');
  const [roomTypesGroups, setRoomTypesGroups] = useState(null);
  const [schema, setSchema] = useState(null);
  const [property, setProperty] = useState(null);
  const [vendor, setVendor] = useState(null);

  useEffect(() => {
    setLoadingState('loading');

    Promise.all([
      ReservationService.getProperty(propertyId),
      ReservationService.getRoomTypesGroupsSchema(propertyId),
      ReservationService.getRoomTypesGroups(propertyId),
      VendorsService.getVendorById(vendorId),
    ])
      .then(([property, schema, roomTypesGroups, vendor]) => {
        setProperty(property.result);
        setSchema(schema.put.body.schema);
        setRoomTypesGroups(roomTypesGroups.result);
        setVendor(vendor.result);
        setLoadingState('success');
      })
      .catch(() => {
        setLoadingState('failed');
      });
  }, [propertyId]);

  return (
    <Container className="room-types-groups-edit-form">
      {loadingState === 'loading' && <Spinner />}
      {loadingState === 'failed' && <Typography>Something went wrong. Can't load room types groups.</Typography>}
      {loadingState === 'success' && (
        <>
          <Helmet>
            <title>{property?.name || propertyId} | Edit Room Groups</title>
          </Helmet>

          <OfferBreadcrumbs
            vendor={{ label: vendor?.vendor_name || vendor?.name || 'Vendor', href: `/vendors/${vendorId}` }}
            property={{ label: property?.name || 'Property', href: `/vendors/${vendorId}/properties/${propertyId}` }}
            currentPage="Edit room groups"
          />
          <PageHeader title="Edit Room Groups" />

          <Box id="overview" className="property-deal-section">
            <RoomTypesGroupsForm
              schema={schema}
              roomTypesGroups={roomTypesGroups}
              roomTypes={property?.room_types}
              propertyId={propertyId}
            />
          </Box>
        </>
      )}
    </Container>
  );
}
